import React, { useContext, useEffect } from 'react'

import './Cartas.css'
import { PromiseSesionContext } from '../../Machines/ErrorMachine'
import ListCardComponentPokemon from '../../Components/ListCardComponentPokemon/ListCardComponentPokemon';

const Cartas = () => {
  const {error, sendError} = useContext(PromiseSesionContext);

  useEffect(() => {
    // sendError({type: "ERROR", data:{message:"hola", type:"info"}})

}, []);
  

  return (
    <div className='layout-page layout-cardPage'>


      <div className='shopContainer_body'>
        <ListCardComponentPokemon type='inventary' subType='Public' hasPrice hasCart ></ListCardComponentPokemon>

      </div>


    </div>
  )
}

export default Cartas